export const SIGNIN = '/signin'
export const COURSE_EVENT_SIGNUP = '/courses/:token/register'

// export const route = (name, params = {}) => {
//   return Object.entries(params).reduce(
//     (carry, [key, value]) => carry.replace(`:${key}`, value),
//     name
//   )
// }
